module.exports = __webpack_public_path__ + "img/photography_thumbnail-400x300.4cd4a9ea.jpg";